import { Component } from '@angular/core';

@Component({
  selector: 'cf-featured-video',
  templateUrl: './featured-video.component.html',
  styleUrls: ['./featured-video.component.scss'],
})
export class FeaturedVideoComponent {}
